export const setStoreId = (id: string) => localStorage.setItem('storeid', id)
